import { useState, useEffect } from 'react';
import api from './api';

// GST rate (%) from the settings table — single source shared with the server
// (server/utils/unbilled.js getGstRate). Falls back to 18 if unset/unreachable.
export default function useGstRate() {
  const [rate, setRate] = useState(18);
  useEffect(() => {
    api.get('/settings')
      .then(r => {
        const v = parseFloat(r.data?.gst_rate);
        if (Number.isFinite(v)) setRate(v);
      })
      .catch(() => {});
  }, []);
  return rate;
}
